import { render, staticRenderFns } from "./BxCheckbox.vue?vue&type=template&id=2992cfec&"
import script from "./BxCheckbox.vue?vue&type=script&lang=js&"
export * from "./BxCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports